import {
    PRODUCTS_LIST,
    SEARCH_PRODUCTS_LIST,
    LOADING_SEARCH_PRODUCT_LIST,
    CLEAR_SEARCH_PRODUCTS_LIST,
    ADD_PRODUCT,
    DELETE_PRODUCT,
    CLEAR_ITEM,
} from './noBarcode.action';
import { ProductUiDto } from '@whiz-cart/node-shared/models/product/productUiDto';

type NoBarcodeReducerState = {
    productsList: ProductUiDto[];
    searchProductList: ProductUiDto[];
    currentItem: string;
    isLoading?: boolean;
};

type NoBarcodeReducerParam =
    | {
          type: typeof PRODUCTS_LIST;
          payload: ProductUiDto[];
      }
    | {
          type: typeof LOADING_SEARCH_PRODUCT_LIST;
          payload: undefined;
      }
    | {
          type: typeof SEARCH_PRODUCTS_LIST;
          payload: ProductUiDto[];
      }
    | {
          type: typeof CLEAR_SEARCH_PRODUCTS_LIST;
          payload: undefined;
      }
    | {
          type: typeof ADD_PRODUCT;
          payload: ProductUiDto;
      }
    | {
          type: typeof DELETE_PRODUCT;
          payload: string;
      }
    | {
          type: typeof CLEAR_ITEM;
          payload: undefined;
      };

export default (
    state: NoBarcodeReducerState = {
        productsList: [],
        searchProductList: [],
        currentItem: '',
    },
    { type, payload }: NoBarcodeReducerParam,
) => {
    switch (type) {
        case PRODUCTS_LIST:
            return { ...state, productsList: payload };
        case LOADING_SEARCH_PRODUCT_LIST:
            return { ...state, isLoading: true };
        case SEARCH_PRODUCTS_LIST:
            return { ...state, searchProductList: payload, isLoading: false };
        case CLEAR_SEARCH_PRODUCTS_LIST:
            return { ...state, searchProductList: [] };
        case ADD_PRODUCT:
            return { ...state, productsList: [payload, ...state.productsList], currentItem: payload.itemId };
        case DELETE_PRODUCT: {
            const productsList = state.productsList.filter((item) => item.itemId !== payload);
            return { ...state, productsList, isLoading: false, currentId: payload, currentItem: payload };
        }
        case CLEAR_ITEM:
            return { ...state, currentItem: '' };
        default:
            return state;
    }
};
